import _isNumber from "lodash/isNumber";
import { TFunction } from "i18n";
import { PlayingAge } from "shared-types";

export default function getPlayingAgeTitle(t: TFunction, playingAge?: number) {
  if (!_isNumber(playingAge)) return;

  return playingAge === PlayingAge.YPPlayingAgeMinYrs
    ? t("common:label.options.playingAge.month", {
        count: PlayingAge.YPPlayingAgeMinMth,
      })
    : t("common:label.options.playingAge.year", { count: playingAge });
}
